// THIS FILE IS AUTOMATICALLY GENERATED IN:
//
//   build-utils/update-file-index.js
//
// YOU SHOULD NEVER UPDATE THIS FILE DIRECTLY
import AutocompleteComponent from './AutocompleteComponent.vue'

// Export components individually
export { AutocompleteComponent }

// What should happen if the user installs the library as a plugin
export default {
  install(Vue) {
    Vue.component('AutocompleteComponent', AutocompleteComponent)
  }
}



// WEBPACK FOOTER //
// ./autocomplete-component/dist/src/index.js